<template>
    <v-dialog
        v-model="abrir"
        @keydown.esc = "cerrar"
        max-width="550px" 
        scrollable
        persistent>
        
        <v-card ref="form">
            <v-card-title>
                <span class="headline">{{ titulo }}</span>
            </v-card-title>

            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12 sm12 md12>
                            <v-text-field
                                class = "body-1"
                                v-model = "datos['nombre']"
                                label = "Nombre(s)"
                            />
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                            <v-text-field
                                class = "body-1"
                                v-model = "datos['paterno']"
                                label = "Apellido Paterno"
                            />
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                            <v-text-field
                                class = "body-1"
                                v-model = "datos['materno']"
                                label = "Apellido Materno"
                            />
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                            <v-text-field
                                vi-if = "nuevo"
                                class = "body-1"
                                v-model = "datos['usuario']"
                                label = "Nombre de usuario"
                            />
                            <v-text-field
                                vi-else
                                class = "body-1"
                                v-model = "datos['usuario']"
                                label = "Nombre de usuario"
                                readonly
                            />
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                            <v-text-field
                                class = "body-1"
                                v-model = "datos['password']"
                                label = "Contraseña"
                                type = "password"
                            />
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                            <v-select
                                class = "body-1"
                                :items = "cbTipoUsuario"
                                v-model = "datos['tipousuario']"
                                label = "Tipo de usuario"
                                item-text="text"
                                item-value="value"
                            ></v-select>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn
                color="blue darken-1"
                text
                @click="cerrar">Cancelar</v-btn>
                <v-btn
                color="blue darken-1"
                text
                @click="guardar">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import ServiceHandler from '../../ServiceHandler';

export default {
    props: {
        datos: Object,
        abrir: Boolean,
        titulo: String,
        nuevo: Boolean,
    },
    data() {
        return {
            cbTipoUsuario: [
                {"text": "Vaquero", "value": "vaquero"},
                {"text": "Medico", "value": "medico"},
                {"text": "Finanzas", "value": "finanzas"},
                {"text": "Super Administrador", "value": "superadmin"}
            ],
        }
    },
    methods: {
        async guardar() {
            try{
                if (!this.nuevo) {
                    await ServiceHandler.updateElement("usuarios", this.datos);
                    this.cerrar();
                    this.$emit('actualizarTabla');
                    alert("Se han guardado los cambios realizados en el usuario");
                    
                }else{
                    await ServiceHandler.insertElement("animales", this.datos);
                    alert("Se ha creado el nuevo usuario");  
                    this.$emit('actualizarTabla'); 
                }
            }catch(e){
                alert("Hubo un error al guardar la información: " + e.message);
            }
        },
        cerrar() {
            this.$emit('cerrarVentana');
        },
    },
}
</script>